<template>
    <div class="video-settings">
        <zoom-selector orientation="horizontal" />

        <div class="brightness-invert-wrapper">
            <div class="icon-buttons">
                <div class="brightness-icon">
                    <i class="fa fa-sun-o" />
                </div>
                <video-invert-toggle />
            </div>
            <video-brightness-slider />
        </div>
    </div>
</template>

<script>
import ZoomSelector from '../common/ZoomSelector'
import VideoInvertToggle from '../common/VideoInvertToggle'
import VideoBrightnessSlider from '../common/VideoBrightnessSlider'

export default {
    name: 'VideoSettings',
    components: {
        ZoomSelector,
        VideoInvertToggle,
        VideoBrightnessSlider
    }
}
</script>

<style lang="scss" scoped>
.video-settings {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background-color: $dark-5;

    .zoom-selector,
    .brightness-invert-wrapper {
        margin: 0 30px;

        @media screen and #{$new-break2close} {
            width: calc(100% - 60px);
        }
        @media screen and #{$new-break3open} {
            width: 160px;
        }
    }

    .brightness-invert-wrapper {
        margin-bottom: 5rem;

        @media screen and #{$new-break2close} {
            display: grid;
            column-gap: 20px;
            grid-template-columns: 1fr 2fr;
        }
    }

    .icon-buttons {
        height: 60px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        background-color: $dark-4;
        border-radius: $border-radius;
        margin-bottom: 0;

        .brightness-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0.25rem;
            border-right: 0.1rem solid $dark-2;
        }
    }

    .video-brightness-slider {
        margin-top: 20px;
    }
}
</style>

<style lang="scss">
.video-settings-panel {
    .icon-buttons {
        .fa-sun-o,
        .fa-adjust {
            color: $light-3;
            font-size: 18pt;
        }
    }

    .video-brightness-slider .brightness-slider {
        padding: 0;
        background-color: unset;

        .slider.slider-horizontal {
            .slider-track {
                height: 0.5rem;
            }
            .slider-handle {
                width: 1.5rem;
                height: 1.5rem;
                top: -0.2rem;
            }
        }
    }
}
</style>
